<template>
    <div>
        
        <div class="statistcs-container">
            <el-row :gutter="16">
            <el-col :span="8">
                <div class="statistic-card">
                <el-statistic :value="'1,750'">
                    <template #title>
                    <div style="display: inline-flex; align-items: center">
                        Total Active Users
                        <el-tooltip
                        effect="dark"
                        content="Number of total units prices "
                        placement="top"
                        >
                        <el-icon style="margin-left: 4px" :size="12">
                            <Warning />
                        </el-icon>
                        </el-tooltip>
                    </div>
                    </template>
                </el-statistic>
                <div class="statistic-footer">
                    <div class="footer-item">
                    <span>than yesterday</span>
                    <span class="green">
                        24%
                        <el-icon>
                        <CaretTop />
                        </el-icon>
                    </span>
                    </div>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="statistic-card">
                <el-statistic :value="users.total">
                    <template #title>
                    <div style="display: inline-flex; align-items: center">
                        Total Users
                        <el-tooltip
                        effect="dark"
                        content="Number of Total Units"
                        placement="top"
                        >
                        <el-icon style="margin-left: 4px" :size="12">
                            <Warning />
                        </el-icon>
                        </el-tooltip>
                    </div>
                    </template>
                </el-statistic>
                <div class="statistic-footer">
                    <div class="footer-item">
                    <span>month on month</span>
                    <span class="red">
                        12%
                        <el-icon>
                        <CaretBottom />
                        </el-icon>
                    </span>
                    </div>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="statistic-card">
                <el-statistic :value="72000" title="New transactions today">
                    <template #title>
                    <div style="display: inline-flex; align-items: center">
                        New transactions today
                    </div>
                    </template>
                </el-statistic>
                <div class="statistic-footer">
                    <div class="footer-item">
                    <span>than yesterday</span>
                    <span class="green">
                        16%
                        <el-icon>
                        <CaretTop />
                        </el-icon>
                    </span>
                    </div>
                    <div class="footer-item">
                    <el-icon :size="14">
                        <ArrowRight />
                    </el-icon>
                    </div>
                </div>
                </div>
            </el-col>
            </el-row>
        </div>
        
        
        <div class="table-main-actions-container">
            <div class="table-actions-container">
            <div class="row">
                <div class="sorting-container col-4">
                <el-button
                        type="info"
                        link
                        @click="refreshUsers"
                        >
                        <font-awesome-icon icon="fa-solid fa-compass-drafting"/> <span style="margin-left:5px;"> All Users </span>
                        </el-button>
                </div>
                <div class="col-8 table-actions">
                    <ul class="actions-list" v-if="users.data">
                        <li><el-button v-if="store.getters['auth/getUserType'] == 'Admin'" :class="'add-btn danger'" type="danger" @click="openAddForm"><font-awesome-icon icon="fa-solid fa-plus"/> Add New</el-button></li>
                        <li >
                            <el-button
                                v-if="!isSearch"
                                type="info"
                                link
                                @click="isSearch = !isSearch"
                            >
                            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Search
                            </el-button>
                            <el-input
                                v-if="isSearch"
                                v-model="searchValue"
                                style="max-width: 300px"
                                placeholder="Please input"
                                class="input-with-select"
                            >
                            <template #append>
                                <el-button style="width: 30px;" @click="searchUsers">
                                <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                                </el-button>
                            </template>
                            </el-input>
                        </li>
                    </ul>
                </div>
            </div>
            </div>
        </div>



        <el-table :row-class-name="tableRowClassName" v-loading="isLoading" element-loading-text="Loading..." element-loading-background="rgba(255, 255, 255, 0.8)" :data="users.data" style="width: 100%" :header-row-class-name="'table-header-style'" :header-cell-class-name="'table-header-cell-style'" :highlight-current-row="true" :cell-class-name="'custom-cell'">
            <el-table-column 
                label="ID"  
                width="120"
                
            >
                <template #default="scope"> 
                    <el-link
                        type="primary"
                        :underline="false"
                        @click="navigateToProfile(scope.row.id)"
                    >
                        #{{ scope.row.id }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column 
                label="First name" 
            >
            <template #default="scope">
                {{  scope.row.first_name }}

            </template>
            </el-table-column>
            <el-table-column 
                label="Last name" 
                
                
            >
            <template #default="scope">
                {{  scope.row.last_name }}
            </template>
            </el-table-column>
            <el-table-column 
                label="Email" 
                :show-overflow-tooltip="true"
                
            >
            <template #default="scope">
                {{  scope.row.email }}

            </template>
            </el-table-column>
            <el-table-column 
                label="Phone number" 
                
                
            >
                <template #default="scope">
                    <el-button  text circle @click="openWhatsApp(scope.row.phone)">
                        <font-awesome-icon icon="fa-brands fa-square-whatsapp" size="xl" style="color: #008f64;" />
                    </el-button>
                    <a :href="`tel:${scope.row.phone}`">
                        <el-button style="margin-left: 0px;  margin-right: 5px; background-color: #005980;  border: none; border-radius: 2px;  width: 18px; height: 18px;" circle>
                            <font-awesome-icon icon="fa-solid fa-phone" size="xs" style="color: #fff;" />
                        </el-button>
                    </a>
                    {{  scope.row.phone }}

                </template>
            </el-table-column>

            <el-table-column 
                label="Account Type" 
                width="150"
                
            >
                <template #default="scope">
                    {{  scope.row.account_type }}

                </template>
            </el-table-column>
            
            <el-table-column 
                label="Registration Type" 
          
            >
            
            <template #default="scope">
                
                <el-tag
                    
                    :type="scope.row.registeration_type == 'Business' ? 'warning' : 'primary'"
                    effect="light"
                    
                    > 
                    {{  scope.row.registeration_type }}
                </el-tag>
            </template>
            </el-table-column>
            
            <el-table-column align="center" fixed="right" width="150">
                <template #header>
                    Actions
                </template>
                <template #default="scope">
                    <el-button type="success" size="small" @click="goToUnits(scope.row.id)" :icon="HomeFilled" 
                    circle plain />

                    <el-button v-if="store.getters['auth/getUserType'] == 'Admin'" size="small" plain @click="openEditForm(scope.$index)" :icon="Edit" 
                    circle />
                    
                    <el-button
                        v-if="store.getters['auth/getUserType'] == 'Admin'"
                        size="small"
                        type="danger"
                        :icon="Delete" 
                        circle
                        plain
                        @click="deleteUser(scope.row.id)"
                    />
                </template>
            </el-table-column>
        </el-table>

        <el-drawer
            
            
            v-model="isEdit"
            :title="'Edit User'"
            :direction="'rtl'"
            :modal-class="'add-project-modal-drawer'"
            :before-close="closeEdit"
        >
            <el-form
            ref="ruleEditFormRef"
            :model="Edited_model"
            :rules="rules"
            label-width="auto"
            class="demo-ruleForm"
            :label-position="'top'"
            :size="'default'"
            status-icon
            >

                

                <el-form-item prop="first_name" label="First Name">
                    <el-input
                        v-model="Edited_model.first_name"
                        type="text"
                        placeholder="First name "
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="last_name" label="Last Name">
                    <el-input
                        v-model="Edited_model.last_name"
                        type="text"
                        placeholder="Last name "
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="email" label="Email Address">
                    <el-input
                        v-model="Edited_model.email"
                        type="text"
                        placeholder="Email@example.com "
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="account_type" label="Account Type">
                    <el-select
                        v-model="Edited_model.account_type"
                        filterable
                        default-first-option
                        :reserve-keyword="false"
                        placeholder="Account Type"
                        
                        >
                        <el-option
                            v-for="type in account_types"
                            :key="type"
                            :label="type"
                            :value="type"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="CRM Role" v-if="Edited_model.account_type != 'Normal' && Edited_model.account_type != null">
                    <el-select
                        v-model="Edited_model.role_id"
                        filterable
                        default-first-option
                        :reserve-keyword="false"
                        placeholder="CRM"
                        
                        >
                        <el-option
                            v-for="role in rolesList"
                            :key="role.id"
                            :label="role.name"
                            :value="role.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item prop="registeration_type" label="Registration Type">
                    <el-select
                        v-model="Edited_model.registeration_type"
                        filterable
                        default-first-option
                        :reserve-keyword="false"
                        placeholder="Registration Type"
                        
                        >
                        <el-option
                            v-for="reg in registration_types"
                            :key="reg"
                            :label="reg"
                            :value="reg"
                        />
                    </el-select>
                </el-form-item>
                
                <el-form-item prop="phone" label="Phone">
                    <el-input
                        v-model="Edited_model.phone"
                        type="text"
                        placeholder="Phone Number "
                        clearable
                    />
                </el-form-item>
                
                <el-form-item prop="password" label="Password">
                    <el-input
                        v-model="Edited_model.password"
                        type="password"
                        placeholder="8 char at least"
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="confirm_password" label="Confirm Password">
                    <el-input
                        v-model="Edited_model.confirm_password"
                        type="password"
                        placeholder="Confirm Password"
                        clearable
                    />
                </el-form-item>
                



            </el-form>
            <template #footer>
                <div style="flex: auto">
                    
                    <el-button v-loading.fullscreen.lock="isAddFormLoading" @click="closeEdit">cancel</el-button>
                    <el-button type="primary" @click="EditUser()">Update User</el-button>
                    
                </div>
            </template>
        </el-drawer>

        <el-drawer
            
            
            v-model="isAdd"
            :title="'Add User'"
            :direction="'rtl'"
            :modal-class="'add-project-modal-drawer'"
            :before-close="handleAddUserClose"
        >
            <el-form
            ref="ruleFormRef"
            :model="add_model"
            :rules="rules"
            label-width="auto"
            class="demo-ruleForm"
            :label-position="'top'"
            :size="'default'"
            status-icon
            >

                

                <el-form-item prop="first_name" label="First Name">
                    <el-input
                        v-model="add_model.first_name"
                        type="text"
                        placeholder="First name "
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="last_name" label="Last Name">
                    <el-input
                        v-model="add_model.last_name"
                        type="text"
                        placeholder="Last name "
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="email" label="Email Address">
                    <el-input
                        v-model="add_model.email"
                        type="text"
                        placeholder="Email@example.com "
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="account_type" label="Account Type">
                    <el-select
                        v-model="add_model.account_type"
                        filterable
                        default-first-option
                        :reserve-keyword="false"
                        placeholder="Account Type"
                        
                        >
                        <el-option
                            v-for="type in account_types"
                            :key="type"
                            :label="type"
                            :value="type"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="CRM Role" v-if="add_model.account_type != 'Normal' && add_model.account_type != null">
                    <el-select
                        v-model="add_model.role_id"
                        filterable
                        default-first-option
                        :reserve-keyword="false"
                        placeholder="CRM"
                        
                        >
                        <el-option
                            v-for="role in rolesList"
                            :key="role.id"
                            :label="role.name"
                            :value="role.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item prop="registeration_type" label="Registration Type">
                    <el-select
                        v-model="add_model.registeration_type"
                        filterable
                        default-first-option
                        :reserve-keyword="false"
                        placeholder="Registration Type"
                        
                        >
                        <el-option
                            v-for="reg in registration_types"
                            :key="reg"
                            :label="reg"
                            :value="reg"
                        />
                    </el-select>
                </el-form-item>
                
                <el-form-item prop="phone" label="Phone">
                    <el-input
                        v-model="add_model.phone"
                        type="text"
                        placeholder="Phone Number "
                        clearable
                    />
                </el-form-item>
                
                <el-form-item prop="password" label="Password">
                    <el-input
                        v-model="add_model.password"
                        type="password"
                        placeholder="8 char at least"
                        clearable
                    />
                </el-form-item>
                <el-form-item prop="confirm_password" label="Confirm Password">
                    <el-input
                        v-model="add_model.confirm_password"
                        type="password"
                        placeholder="Confirm Password"
                        clearable
                    />
                </el-form-item>
                



            </el-form>
            <template #footer>
                <div style="flex: auto">
                    
                    <el-button v-loading.fullscreen.lock="isAddFormLoading" @click="handleAddUserClose">cancel</el-button>
                    <el-button type="primary" @click="handleAddSubmit">Add User</el-button>
                    
                </div>
            </template>
        </el-drawer>

        <div class="pagination-container">
            <el-pagination
            :page-size="users.per_page"
            :pager-count="11"
            :size="'small'"
            layout="prev, pager, next"
            :total="users.total"
            :background="true"
            :disabled="isDisabled"
            :current-page="page"
            @current-change="paginationChanged"
            />
      </div>
    </div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, ref , computed , reactive } from 'vue';
import { useStore } from 'vuex';
import {
  ArrowRight,
  CaretBottom,
  CaretTop,
  Check,
  Warning,
  Delete,
  Edit,
  Close,
  Search ,
  View,
  HomeFilled,
} from '@element-plus/icons-vue'

import { useRouter } from 'vue-router';
export default {
    name: 'Users',
    setup(){
        const store = useStore();
        const page = ref(1);
        const isLoading = ref(false);
        const users = ref([]);
        const Edited_model = ref({});
        const isSearch = ref(false);
        const isDisabled = ref(false);
        const isAdd = ref(false);
        const searchValue = ref('');
        const ruleFormRef = ref(null);
        const ruleEditFormRef = ref(null);
        const isAddFormLoading = ref(false);
        const router = useRouter();
        const isEdit = ref(false);
        const rolesList = ref([
            {
                id:3,
                name:"Admin"
            },
            {
                id:2,
                name:"Sales"
            },
            {
                id:4,
                name:"Team Leader"
            },
        ])
        const account_types = ref([
            'Normal','Sales','Admin','Authorize'
        ]);
        const registration_types = ref([
            'Client','Business'
        ]);

        const rules = reactive({
            first_name: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            last_name: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            phone: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            account_type: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            registeration_type: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            email: [
                {
                required: true,
                message: '@Required',
                trigger: 'blur',
                },
                {
                validator: (rule, value) => {
                    if (!value) return new Error('@Required');
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (!emailRegex.test(value)) {
                    return new Error('Please enter a valid email address.');
                    }
                    return true;
                },
                trigger: 'blur',
                },
            ],
            password: [
                { 
                message: '@Required', 
                trigger: 'blur' 
                },
                { 
                validator: (rule, value) => {
                    if (!value && Edited_model.value.email != null){
                        return true;
                    }
                    if (!value) return new Error('@Required');
                        // Check if password is at least 8 characters and contains both letters and numbers
                        const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
                    if (!passwordRegex.test(value)) {
                        return new Error('Password must be at least 8 characters long and contain both letters and numbers.');
                    }
                    return true;
                },
                trigger: 'blur'
                }
            ],
            confirm_password: [
                {  
                message: '@Required', 
                trigger: 'blur' 
                },
                { 
                validator: (rule, value) => {
                    if (!value && Edited_model.value.password == null || Edited_model.value.password == ''){
                        return true;
                    }
                    if (!value) return new Error('@Required');
                    if (value !== add_model.password && value !== Edited_model.value.password) {
                        return new Error('Passwords do not match.');
                    }
                    return true;
                },
                trigger: 'blur'
                }
            ],
        });
        const add_model = reactive({
            first_name:null,
            last_name:null,
            account_type:null,
            email:null,
            role_id:null,
            phone:null,
            registeration_type:null,
            password:null,
            confirm_password:null,
        });
        const searchUsers = async () => {
            if(searchValue.value && searchValue.value != " " ){
                isLoading.value = true;
                const value = searchValue.value;
                const pageno = page.value;
                await store.dispatch('users/searchUsers' , { value:value , page:pageno})
                users.value = store.getters['users/getUsers'];
                isLoading.value = false;
            }
        };
        const openAddForm = () => {
            add_model.first_name , add_model.last_name , add_model.account_type , add_model.registeration_type , add_model.password , add_model.email , add_model.phone= null;
            isAdd.value = true;
        };
        const navigateToProfile = (id) => {
            if(store.getters['auth/getUserType'] =="Admin"){
                router.push({ name: 'profile', params: { userId: id } });
            }
        };
        const openWhatsApp = (  cellValue ) => {
            const message = `*Hi, This is TAP Egypt `;
            const url = `https://wa.me/${cellValue}?text=${encodeURIComponent(message)}`;
            window.open(url, '_blank');  // Opens WhatsApp in a new tab or app
        };
        const deleteUser = async (id) => {
            ElMessageBox.confirm(
            'Are you sure delete the user. Continue?',
            'Warning',
            {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning',
            }
            )
            .then( async () => {
                isLoading.value = true;
                await store.dispatch('users/deleteUser' , id);
                ElMessage({
                type: 'success',
                message: 'Delete successfull',
                })
                users.value = store.getters['users/getUsers'];
                isLoading.value = false;
            })
            .catch(() => {
                isLoading.value = false;
                ElMessage({
                type: 'warning',
                message: 'Delete canceled',
                })
            })
        };
        const paginationChanged = async (value) => {
            page.value= value;
            const pageno = page.value;
            isLoading.value = true;
            isDisabled.value = true;
            const svalue = searchValue.value;
            if(svalue){
                await store.dispatch('users/searchUsers' , { value:svalue , page:pageno});
            }
            else{
                await store.dispatch('users/fetchUsers' , pageno);
            }
            users.value = store.getters['users/getUsers'];
            isDisabled.value = false;
            isLoading.value = false;
        };
        // Method to navigate to the units page with userId
        const goToUnits = (userId) => {
            router.push({ name: 'units', params: { userId } });
        };
        onMounted(async () => {
            isLoading.value = true;
            await store.dispatch('users/fetchUsers' , page.value);
            users.value = store.getters['users/getUsers'];
            isLoading.value = false;
        });
        const openEditForm = (row) => {
            //get backup of row
            Edited_model.value = {
                ...users.value.data[row],
                password:null,
                confirm_password:null,
            } ;
            isEdit.value = true;
            //close all forms and open only selected row
            //users.value.data.map(user => user.is_edit_active = false);
            //users.value.data[row].is_edit_active = true;
            //delete Edited_model.value.photo_link;
        }
        const closeEdit = () => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            confirmButtonText: 'Cancel',
            cancelButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            ElMessage({
                type: 'info',
                message: 'Canceld.',
            })
            })
            .catch(() => {
                Edited_model.value = {};
                isEdit.value = false;
                //users.value.data[row].is_edit_active = false;
            ElMessage({
                type: 'info',
                message:'Changes Discribed',
            })
            })
            
        };
        const EditUser = async (index) => {
            const form = ruleEditFormRef.value; // Access the form instance
            if (!form) return;
                // Validate the form
                await form.validate(async (valid, fields) => {
                    if (valid) {
                        try {
                            isLoading.value = true;

                            

                            

                            await store.dispatch('users/updateUser' , Edited_model.value);
                            await store.dispatch('users/fetchUsers' , page.value);
                            users.value = store.getters['users/getUsers'];
                            
                            isEdit.value = false;
                            
                            ElMessage({
                                type: 'success',
                                message: 'User is Updated Successfully',
                            })
                        } catch (error) {
                            ElMessage({
                            type: 'error',
                            message: 'Something Went Wrong ...',
                            })
                        } finally {
                            isLoading.value = false;
                            
                        }
                    } else {
                        console.log('Form is invalid:', fields);
                    }
                }
            );


        };
        const refreshUsers = async () => {
            page.value = 1;

            isLoading.value = true;
            searchValue.value = '';
            await store.dispatch('users/fetchUsers' , page.value);
            users.value = store.getters['users/getUsers'];
            isLoading.value = false;
        };
        const handleAddUserClose = () => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            isAdd.value = false;
            resetForm();
            ElMessage({
                type: 'info',
                message: 'Changes Discribed',
            })
            })
            .catch(() => {
            
            ElMessage({
                type: 'info',
                message:'Canceld',
            })
            })
            
        };
        const handleAddSubmit = async () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;
                // Validate the form
                await form.validate(async (valid, fields) => {
                    if (valid) {
                        try {
                            isAddFormLoading.value = true;

                            

                            

                            // Send the form data to the store's action
                            await store.dispatch('users/addNewUser', add_model);
                            resetForm();
                            
                            isAdd.value = false;
                            ElMessage({
                                type: 'success',
                                message: 'User is Added Successfully',
                            })
                            
                        } catch (error) {
                            ElMessage({
                            type: 'error',
                            message: 'Something Went Wrong ...',
                            })
                        } finally {
                            isAddFormLoading.value = false;
                        }
                    } else {
                        console.log('Form is invalid:', fields);
                    }
                }
            );
        };
        const resetForm = () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;

            // Reset the form fields
            form.resetFields();
        };
        const addImageToList = (file,fileList)=> {
            /* add_model.photo_link = file.raw;
            console.log(add_model); */
        }
        return {
            ruleEditFormRef,
            router,
            goToUnits,
            registration_types,
            account_types,
            isAdd,
            add_model,
            store,
            users,
            page,
            isDisabled,
            isLoading,
            Edited_model,
            isSearch,
            searchValue,
            isAddFormLoading,
            ArrowRight,
            CaretBottom,
            CaretTop,
            rolesList,
            Check,
            HomeFilled,
            Warning,
            Delete,
            Edit,
            Close,
            Search ,
            View,
            ruleFormRef,
            resetForm,
            rules,
            openEditForm,
            closeEdit,
            EditUser,
            refreshUsers,
            paginationChanged,
            searchUsers,
            deleteUser,
            openAddForm,
            handleAddUserClose,
            handleAddSubmit,
            addImageToList,
            openWhatsApp,
            navigateToProfile,
            isEdit,
        }
    }
}
</script>

<style lang="scss">
.el-drawer{
    .upload-project-demo{
        width: 100%;
    }
  ::-webkit-scrollbar {
    width: 4px;
    transition: 0.2s ease-in-out;
  }
  /* ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    transition: 0.2s ease-in-out;
  }
  &:hover{
    ::-webkit-scrollbar-thumb {
      transition: 0.2s ease-in-out;
      background: #034750;
    }
  } */
}
.add-project-modal-drawer{
  
  @media (max-width:761px){
    .el-drawer{
      width: 100% !important;
    }
  }
  @media (min-width:762px){
    .el-drawer{
      width: 90% !important;
    }
  }
  @media (min-width:992px){
    .el-drawer{
      width: 50% !important;
    }
  }
  @media (min-width:1200px){
    .el-drawer{
      width: 23% !important;
    }
  }
}
@import '../assets/styles/table.scss';


.upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.upload-list .el-upload-list__item {
  cursor: move;
}

</style>
  
  // statistics Style
  <style scoped>
  .statistcs-container{
    margin-bottom: 50px;
  }
  :global(h2#card-usage ~ .example .example-showcase) {
    background-color: var(--el-fill-color) !important;
  }
  
  .el-statistic {
    --el-statistic-content-font-size: 28px;
  }
  
  .statistic-card {
    height: 100%;
    padding: 15px;
    border-radius: 10px;
    background-color: #d8e5e78f;
    /* border: solid 1px #f1f1f1; */
  }
  
  .statistic-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-size: 12px;
    color: var(--el-text-color-regular);
    margin-top: 16px;
  }
  
  .statistic-footer .footer-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .statistic-footer .footer-item span:last-child {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
  }
  
  .green {
    color: var(--el-color-success);
  }
  .red {
    color: var(--el-color-error);
  }
  </style>